// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__icfwe","content":"styles_content__22LKE","checkbox":"styles_checkbox__2MxZ3","checkboxLabel":"styles_checkboxLabel__21EEV"};